import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IDataServiceEntityFileEntry } from 'src/app/services/data.service.interface';
import { IFormFileEntryListActions } from '../form-file-entry-list/form-file-entry-list.component';
import { FormInputComponent, IFormInputViewModel } from '../form-input/form-input.component';


@Component({
  selector: 'app-file-entry',
  templateUrl: './form-file-entry.component.html',
  styleUrls: ['./form-file-entry.component.scss']
})
export class FormFileEntryComponent implements OnInit {

  constructor(protected domSanitizer: DomSanitizer) { }

  @Input() vm: IFormFileEntryViewModel;
  @Input() actions: IFormFileEntryListActions;

  imageSrc: any;

  /**
   * 
   */
  ngOnInit() {
    // if ((this.vm.data.fileUrl || '').toUpperCase().startsWith('DATA:')) {
    //   this.imageSrc = this.domSanitizer.bypassSecurityTrustUrl(this.vm.data.fileUrl);
    // } else {
    //   this.imageSrc = this.vm.data.fileUrl;
    // }
  }

  /**
   *
   * @param data
   * @param changeFunc
   */
  public static viewModel(data: IDataServiceEntityFileEntry, changeFunc: () => void): IFormFileEntryViewModel {
    const ret: IFormFileEntryViewModel = {
      data: data,
      description: FormInputComponent.viewModel(data, 'description', { title: 'Description', type: 'text' })
    };
    return ret;
  }

}

/**
*
*/
export interface IFormFileEntryViewModel {
  data: IDataServiceEntityFileEntry;

  description: IFormInputViewModel;

  isPrimary?: boolean;
}